import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/albertine-icon.svg";
import type { Agent } from "../../common/types/Agent";
import MenuLinks from "./MenuLinks";
import ProfileDropdown from "./ProfileDropdown";
import "./Menu.css";

type Props = {
    currentAgent: Agent;
};

const Menu = function Menu(props: Props) {
    const { currentAgent } = props;

    return (
        <div className="tab menu-tab">
            <div className="menu">
                {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
                <Link to="/" className="menu__title">
                    <img src={logo} className="menu__logo" alt="Albertine" />{" "}
                </Link>
                <MenuLinks currentAgent={currentAgent} />
            </div>

            <ProfileDropdown currentAgent={currentAgent} />
        </div>
    );
};

export default Menu;
